var filterLocationReducer = (state = [], action) => {
  switch (action.type) {
    case "ADD_LOCATION":
      return [...state, action.id];
    case "EMPTY_LIST":
        return [];
    case "REMOVE_LOCATION":
        let temp = JSON.parse(JSON.stringify(state));
        let itemIndex = temp.map(item => {
                return item;
                })
        .indexOf(action.id);
        temp.splice(itemIndex, 1);
        return temp;

    default:
      return state;
  }
};

export default filterLocationReducer;



// WEBPACK FOOTER //
// ./src/modules/filterLocation/filterLocationReducers.js